import Component from './component';
import transformer from './transformer';

const EventCard = (props) => <Component {...transformer(props)} />;

export default EventCard;

export { Component as component };
